import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'table.assets.assetNameColumn';
    property = 'name';
    sortable = true;
    sortField = 'name';
    type: CellDisplay = CellDisplay.string;
}
